import React from "react";
import { Collapse, Modal, Typography } from "antd";
import rewardsGuide from "../rewardsGuideContent";

function RewardsGuide({ visible, onClose }) {
  return (
    <Modal
      title="Referrals and ride rewards: administrator guide"
      open={visible}
      onCancel={onClose}
      onOk={onClose}
      okText="Close guide"
      cancelButtonProps={{ style: { display: "none" } }}
      width={800}
      bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
    >
      <Typography.Paragraph>
        Select a topic for instructions. Campaign values and access permissions
        determine which actions are available to you.
      </Typography.Paragraph>
      <Collapse defaultActiveKey={["Access and navigation"]}>
        {rewardsGuide.map((section) => (
          <Collapse.Panel key={section.title} header={section.title}>
            {section.steps.map((step) => (
              <Typography.Paragraph key={step}>{step}</Typography.Paragraph>
            ))}
          </Collapse.Panel>
        ))}
      </Collapse>
    </Modal>
  );
}

export default RewardsGuide;
